import { IonCardTitle } from '@ionic/react';
import styled from 'styled-components';

export const IonTitleLogin = styled(IonCardTitle)`
  margin-bottom: 3%;
  padding-left: 0;
  color: var(--ion-text-color);
  font-weight: bold;
  font-size: 1rem;
  font-family: 'Inter-ExtraBold', sans-serif;
`;
